import DeleteModal from '@Components/Modal/DeleteModal';
import { useDisclosure } from '@hooks/useDisclosure';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { useGreenhouseForm } from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider';
import { ICarbonDetailFormValues } from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider/types';
import { useWatch } from 'react-hook-form';

type CarbonActionsProps = { rowId: number | string };

const CarbonNeutralityDeleteRow = ({ rowId }: CarbonActionsProps) => {
  const [opened, { open, close }] = useDisclosure();
  const { getValues, setValue } = useGreenhouseForm();

  const isNewDetails = typeof rowId === 'string';

  const completedSection = useWatch({
    name: 'greenhouseGoalTerm.completedSection',
  });

  const { isCompletedTh, isCompletedEn } = completedSection ?? {};

  const handleDelete = () => {
    const prevCarbon = getValues(
      'greenhouseGoalTerm.carbon.details'
    ) as ICarbonDetailFormValues[];

    const currentIndex = isNewDetails
      ? Number(rowId.replace('NEW-', '')) - 1
      : prevCarbon.findIndex((detail) => detail.id === rowId);

    const updateCarbonNeutrality = prevCarbon?.filter(
      (_, index) => index !== currentIndex
    );

    setValue('greenhouseGoalTerm.carbon.details', updateCarbonNeutrality);
    close();
  };

  return (
    <>
      <GridActionsCellItem
        key="delete"
        icon={<DeleteOutlineIcon style={{ fontSize: '16px' }} />}
        label="Delete"
        onClick={open}
        disabled={isCompletedTh || isCompletedEn}
      />

      <DeleteModal
        topic={
          'รายละเอียดการตั้งเป้าหมายความเป็นกลางทางคาร์บอน (Carbon Neutrality)'
        }
        opened={opened}
        close={close}
        confirm={handleDelete}
      />
    </>
  );
};

export default CarbonNeutralityDeleteRow;
